// Validation to require at least one checked
import {
    AbstractControl,
    FormArray,
    UntypedFormArray,
    ValidationErrors,
    ValidatorFn,
    Validators
} from '@angular/forms';
import dayjs from 'dayjs';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

export class CustomValidators {
    static emailWithAtAndPeriod = Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$');

    static multipleCheckboxRequireOne(fa: UntypedFormArray) {
        let valid = false;

        for (const el of fa.controls) {
            if (el.value) {
                valid = true;
            }
        }

        return valid
            ? null
            : {
                  multipleCheckboxRequireOne: true
              };
    }

    static requiredIfValidator(predicate: { (): any; (): boolean; (): boolean; (): any }) {
        return (formControl: AbstractControl) => {
            if (!formControl.parent) {
                return null;
            }

            if (predicate()) {
                return Validators.required(formControl);
            }
            return null;
        };
    }

    static minDate(date: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (isEmpty(control.value)) {
                return null;
            }

            const FORMAT_DATE = 'MM/DD/YYYY'; // Define your date format here

            const controlDate = dayjs(control.value, FORMAT_DATE);

            if (!controlDate.isValid()) {
                return null;
            }

            const validationDate = dayjs(date, FORMAT_DATE);

            return controlDate.isAfter(validationDate)
                ? null
                : {
                      'min-Date': {
                          'min-Date': validationDate.format(FORMAT_DATE),
                          actual: controlDate.format(FORMAT_DATE)
                      }
                  };
        };
    }

    static payRangeFromToValidator(controlFromName: string, controlToName: string) {
        return (group: AbstractControl): ValidationErrors | null => {
            const fromPayRange = group.get(controlFromName)?.value;
            const toPayRange = group.get(controlToName)?.value;
            if (!fromPayRange || !toPayRange) {
                return null;
            }
            if (fromPayRange > toPayRange) {
                group.get(controlToName).setErrors({ incorrect: true });
                group.get(controlFromName).setErrors({ incorrect: true });
                return {
                    payRangeInvalid: true
                };
            } else {
                group.get(controlFromName).setErrors(null);
                group.get(controlToName).setErrors(null);
                return null;
            }
        };
    }

    /**
     * A validator that ensures a formArray control is full of valid controls
     */
    static formArrayValidator(): ValidatorFn {
        return (formArray: FormArray): ValidationErrors | null => {
            if (formArray && formArray.controls) {
                const invalidControls = formArray.controls.filter((c) => !c.valid);
                if (invalidControls && invalidControls.length > 0) {
                    // Return an error object if any of the FormArray's controls are invalid.
                    return { formArrayInvalid: true };
                }
            }

            // If all controls are valid or if there are no controls, return null.
            return null;
        };
    }
}
